import type { QueryClient } from 'react-query';

const clients = new Set<QueryClient>();
let session = 0;
export const planningSession = (client: QueryClient) => {
  clients.add(client);
  return session;
};

// Called by every logout/session-expiry path, including automatic refresh failure.
export const clearPlanningCache = () => {
  session += 1;
  clients.forEach(client => client.removeQueries(['planning']));
  clients.clear();
};
